<template>
  <div class="spcore hvh-flex h-100">
    <div class="filter px-2" v-if="$store.state.showSPCoreFilter">
      <div class="mt-2 mb-2">
        <v-icon @click="$store.state.showSPCoreFilter = !$store.state.showSPCoreFilter">mdi-menu</v-icon>
      </div>
      <slot name="filter" />
    </div>
    <div class="grow-1 overflow-hidden">
      <div class="hvh-flex column h-100">
        <div class="hvh-flex align-center background-white">
          <div class="menu-icon p-2" v-if="!$store.state.showSPCoreFilter">
            <v-icon @click="$store.state.showSPCoreFilter = !$store.state.showSPCoreFilter">mdi-menu</v-icon>
          </div>
          <div class="overflow-hidden">
            <SPCoreMenu class="mt-2" />
          </div>
        </div>
        <div class="grow-1 hvh-flex wrap" :style="{ backgroundColor: 'white' }">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import SPCoreMenu from './menu/SPCoreMenu.vue'
export default {
  noExport: true,
  components: { SPCoreMenu },
}
</script>

<style lang="scss" scoped>
.filter {
  width: 200px;
  min-width: 200px;
  background-color: #cce3e7;
}

.menu-icon {
  background-color: #cce3e7;
}
</style>